module.exports = __webpack_public_path__ + "img/d18.79abc3fe.png";